import { useEffect } from 'react';

import type { UseViewSendoutEffectsProps } from '@pages/Sendouts/ViewSendouts/types';

export const useViewSendoutsEffects = ({
  getTimezonesHandler,
  attachmentsHandler,
  titleHandler,
  emptySendoutIdHandler,
}: UseViewSendoutEffectsProps) => {
  useEffect(() => {
    getTimezonesHandler();
  }, [getTimezonesHandler]);

  useEffect(() => {
    attachmentsHandler();
  }, [attachmentsHandler]);

  useEffect(() => {
    titleHandler();
  }, [titleHandler]);

  useEffect(() => {
    emptySendoutIdHandler();
  }, [emptySendoutIdHandler]);
};
